import React from 'react';
import {
  AppBar, Toolbar, IconButton, Typography, Paper, Tabs, Tab, Box, Container, CircularProgress
} from '@mui/material';
import {
  Build as WrenchIcon,
  Security as ShieldIcon,
  CurrencyRupee as IndianRupeeIcon,
  ConfirmationNumber as TicketIcon,
  ArrowBack as ArrowLeftIcon
} from '@mui/icons-material';

const tabIcons = [<WrenchIcon />, <ShieldIcon />, <IndianRupeeIcon />, <TicketIcon />];

export default function DoorLocksFeatureLayout({
  activeTab,
  counts,
  onTabChange,
  onBack,
  children,
  loadingStats
}) {
  return (
    <Box sx={{ minHeight: '100vh' }}>
      
      <Container maxWidth="100" sx={{ py: 4 }}>
        {children}
      </Container>
    </Box>
  );
}